import React, { useState, useEffect, useRef } from 'react';
import Header from "../../../../Components/Header/Header";
import LeftMenu from '../../../../Components/LeftMenu/LeftMenu';
import ImageUpload from '../../../../Components/common/ImageUpload';
import ActivityComments from '../../../../Components/common/ActivityComments';
import Select from 'react-select'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Row, Table, Dropdown, Modal, Tab, Tabs, Stack, Button, Form, Accordion, ModalTitle } from 'react-bootstrap';
import { faPlus, faXmark, faPencil, faPaperclip, faCalendarDays, faCircleXmark, faLink, faCircleCheck, faChevronDown, faGear } from '@fortawesome/free-solid-svg-icons';
import { Link, useHistory } from 'react-router-dom';
import Docmnt from '../../../../assets/images/google-docs.png';
import Arcv from "../../../../assets/images/archive.svg";
import Activ from "../../../../assets/images/active.svg";
import edit from "../../../../assets/images/edit.png";

import view from "../../../../assets/images/chat.png";
import MailGreen from '../../../../assets/images/mail_green.png';
import MailRed from '../../../../assets/images/mail_red.png';
import { withoutRFSToken, withRFSToken } from '../../../../Services/axios.js';
import { GETULDDETAILS, MOVETOACTARC, RECOVERYARCACT, RECOVERYDETAILS, STATIONLIST, STATIONHANDLER, GETOWNERCODE, SAVEHANDLER, SAVERECOVERY, GETSHC } from '../../../../Utils/conts.js';

import { toast } from 'react-toastify';
import Trash from '../../../../assets/images/trash.png';
import { MultiSelect } from 'react-multi-select-component';
import ConfModal from '../../../../Components/common/ConfModal.js';
import { CallApi } from '../../../../Components/common/CommonFunctions.js';

const AddRecovery = ({ onSubmit, onClose, DropData }) => {

    const isMounted = useRef(false);
    const history = useHistory();

    const [getOwnerCodes, setGetOwnerCode] = useState([]);
    const initFData = { all_stations: [], origin_notify_status: 1, destination_notify_status: 1 }
    const [formData, setFormData] = useState(initFData);
    const [getDestination, setGetDestination] = useState([]);
    const [originHandler, setOriginHandler] = useState([]);

    const [reportHandler, setReportHandler] = useState([]);
    const [selectedReportId, setSelectedReportId] = useState(null);
    const [selectedReportHandler, setSelectedReportHandler] = useState(null);

    const [stations, setStations] = useState([
        // { station: '', stationHandler: [], selectedDestinationHandler: null }
    ]);
    const [inputAddress, setInputAddress] = useState({
        handler_org_id: '', address: '', handler_email_id: [''], handler_phone_no: ''
    });
    const [handlerList, setHandlerList] = useState([]);
    const [selectedOriginHandler, setSelectedOriginHandler] = useState(null);
    const [destinationHandler, setDestinationHandler] = useState([]);
    const [selectedDestinationId, setSelectedDestinationId] = useState(null);
    const [addressFor, setAddressFor] = useState('');

    const [addressModalShow, setAddressModalShow] = useState(false);
    const addressModalClose = () => { setAddressModalShow(false); setInputAddress({ handler_org_id: '', address: '', handler_email_id: [''], handler_phone_no: '' }) }
    const [selectedOriginId, setSelectedOriginId] = useState(null);
    const [selectedDestinationHandler, setSelectedDestinationHandler] = useState(null);
    const [address, setAddress] = useState([]);
    // IMAGE UPLOAD START

    const [files, setFiles] = useState([]);
    const [editFiles, setEditFiles] = useState([]);
    const [base64Files, setBase64Files] = useState([]);

    const [disLoading, setDisLoading] = useState(false);
    // IMAGE UPLOAD END

    const [commodityType, setCommodityType] = useState([]);
    const [movementType, setMovementType] = useState([]);
    const [recoveryAspects, setRecoveryAspects] = useState([]);
    const [otherAspects, setOtherAspects] = useState([]);
    const [recoveryInfo, setRecoveryInfo] = useState([]);
    const [getShc, setGetShc] = useState([]);

    const orgDetails = JSON.parse(localStorage.getItem('Handler_stn'));
    // console.log('orgDetails', orgDetails);

    const fetchStationData = async () => {
        try {

            const res = await withRFSToken.post(STATIONLIST, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.port_code,
                        label: item.port_code,
                        address: item.address,
                        station_id: item.station_id
                    })) : [];
                    setGetDestination(transformedData);
                    const reportingStn = transformedData.find(val => val.value == orgDetails.station_name)
                    console.log('reportingStn', reportingStn);
                    setFormData(prevFormData => ({
                        ...prevFormData,
                        reported_station: reportingStn.value,
                        reported_station_id: reportingStn.station_id,
                        // report_handler_id: selectedDestination.address[0].id
                    }));
                    setDisLoading(false)
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchAddressData = async (id, stn) => {
        const payload = {
            stationId: ['report', 'RH'].includes(id) ? selectedReportId : ['origin', 'OH'].includes(id) ? selectedOriginId : ['destination', 'DH'].includes(id) ? selectedDestinationId : stn.station_id
        }
        try {

            const res = await withRFSToken.post(STATIONHANDLER, payload)
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.handler_org_id,
                        label: item.org_name,
                        email: item.handler_email_id
                    })) : [];
                    setHandlerList(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchOwnerCode = async () => {
        try {

            const res = await withRFSToken.post(GETOWNERCODE, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.IATA,
                        label: item.IATA,
                        pref: item.AWB_prefix
                    })) : [];
                    setGetOwnerCode(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchDropdown = async () => {
        try {

            const res = await withRFSToken.post('service-recovery/dropdown-list', {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setCommodityType(innerData.commodity_type);
                    setMovementType(innerData.movement_type);
                    setRecoveryAspects(innerData.recovery_aspects);
                    setRecoveryInfo(innerData.recovery_information);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchSHC = () => {
        CallApi({
            endPoint: GETSHC,
            payload: {},
            onSuccess: (res) => {
                const resCode = res.data.response_code;
                if (resCode === 200) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.value,
                        label: item.code,
                    })) : [];
                    setGetShc(transformedData);
                }
            },
            onError: (msg) => toast.error(msg)
        });
    };
    const fetchSpec = async () => {
        try {

            const res = await withRFSToken.post('get-meta-list', { type_id: '25' })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setOtherAspects(innerData)
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        if (DropData) {
            setCommodityType(DropData.commodity_type);
            setMovementType(DropData.movement_type);
            setRecoveryAspects(DropData.recovery_aspects);
            setRecoveryInfo(DropData.recovery_information);
        }
    }, [DropData])

    useEffect(() => {
        if (isMounted.current) return;
        // Call the fetchData function to fetch data from the API
        // fetchDataGrid();
        setDisLoading(true)
        fetchSpec()
        // fetchDropdown();
        // fetchAddressData();
        fetchOwnerCode();
        fetchStationData();
        fetchSHC();
        // fetchDataGridR();
        isMounted.current = true;
    }, []);
    // useEffect(() => {
    //     if (getDestination.length && getOwnerCodes.length && handlerList.length) {
    //         setDisLoading(false)
    //     }
    // }, [getDestination, getOwnerCodes, handlerList]);


    // upload forward
    const fileInputRef = useRef(null);
    const imageUploadRef = useRef(null);
    const browseClick = () => {
        if (imageUploadRef.current) {
            imageUploadRef.current.handleBrowseFiles();
        }
    };




    const [selectedFile, setSelectedFile] = useState("");
    const [imgShow, setImgShow] = useState(false);
    const [serviceRecoveryShow, setServiceRecoveryShow] = useState(true);
    const handleFileClick = (file) => {
        setSelectedFile(file);
        setImgShow(true);
    };
    const handleClose = () => {
        setImgShow(false);
        setSelectedFile("");
    };


    // ALL FORM
    const handleInputChange = (event) => {
        const { name, value, type, checked } = event.target;

        let newValue = type === 'checkbox' ? checked : value;

        // if (name == 'origin_notify_status') {
        //     console.log('000', checked);

        //     setFormData(prevFormData => ({
        //         ...prevFormData,
        //         origin_notify_status: checked == true ? 1 : 0
        //     }));
        // } else if (name == 'destination_notify_status') {
        //     setFormData(prevFormData => ({
        //         ...prevFormData,
        //         destination_notify_status: checked == true ? 1 : 0
        //     }));
        // }

        if (name === 'master_airway_bill_prefix') {
            // const awbpref = getOwnerCodes?.find(prf => prf.AWB_prefix == value)
            if (value.length === 3) {
                const awbpref = getOwnerCodes?.find(prf => prf.pref === value);
                if (awbpref) {
                    // Update formData with the found flight_prefix
                    setFormData(prevFormData => ({
                        ...prevFormData,
                        master_airway_bill_prefix: value,
                        flight_prefix: awbpref.value
                    }));
                    return; // Exit early to avoid re-setting formData again below
                }
            } else {
                setFormData(prevFormData => ({
                    ...prevFormData,
                    master_airway_bill_prefix: value,
                    flight_prefix: ''
                }));
            }
        }
        if (name === 'master_airway_bill_no') {
            // Remove non-digits, and ensure it doesn't exceed 8 digits
            newValue = handleChange(value);
            const rawValue = newValue.replace(/\D/g, '');
            if (rawValue.length === 8 && formData.master_airway_bill_prefix?.length === 3) {
                const fullAWB = `${formData.master_airway_bill_prefix}-${rawValue}`;
                fetchRecoveryInformation(fullAWB);
            }

        }
        setFormData(prevFormData => {
            // const updatedAwbill1 = name === 'awbill1' ? newValue : prevFormData.awbill1 || '';
            // const updatedAwbill2 = name === 'awbill2' ? newValue : prevFormData.awbill2 || '';

            // return {
            //     ...prevFormData,
            //     [name]: newValue,
            //     master_airway_bill_no: `${updatedAwbill1}-${updatedAwbill2}`
            // };
            // When awbill1 or awbill2 is changed, update master_airway_bill_no
            // if (name === 'awbill1' || name === 'awbill2') {
            //     const newAirwayBill = `${formData.awbill1 || ''}-${formData.awbill2 || ''}`;

            //     return {
            //         ...prevFormData,
            //         [name]: newValue,
            //         master_airway_bill_no: newAirwayBill
            //     };
            // }
            if (name === 'recovery_aspects') {
                const updatedAspects = checked
                    ? [...(prevFormData.recovery_aspects || []), value] // Add the value if checked
                    : (prevFormData.recovery_aspects || []).filter(item => item !== value); // Remove the value if unchecked

                return {
                    ...prevFormData,
                    recovery_aspects: updatedAspects
                };
            }
            return { ...prevFormData, [name]: newValue };
        });
    };
    const handleChange = (value) => {
        // console.log(value);

        value = value.replace(/[^\d]/g, ''); // Remove any non-numeric characters
        let formattedValue = '';

        // Add a space after the first 4 digits
        if (value.length > 4) {
            formattedValue += value.substr(0, 4) + ' ';
            value = value.substr(4);
        }

        formattedValue += value;
        return formattedValue.substr(0, 9); // Limit to 9 characters (8 digits + 1 space)
    };

    const fetchRecoveryInformation = async (awbNumber) => {
        try {
            const res = await withRFSToken.post("service-recovery/recovery-information", { airway_bill: awbNumber });
            if (res.data.response_code === 200 && res.data.response_data != null) {
                const innerData = res.data.response_data;
                setFormData(innerData);
                setConfData({
                    header: `AWB Number is already exist`,
                    subHeader: `Would you like to continue with same AWB number?`,
                    modalConf: 'C',
                    closeModal: '',
                    primaryBtn: 'Continue',
                    secondaryBtn: 'Create New',
                })
                setModalConf(true)
                if (innerData.origin) {
                    const selectedDestination = getDestination.find(option => option.value === innerData.origin);
                    console.log('selectedDestination', selectedDestination);
                    setOriginHandler(selectedDestination ? selectedDestination.address : []);
                    setSelectedOriginId(selectedDestination.station_id);

                    if (selectedDestination && selectedDestination.address.length === 1) {
                        const autoSelectedHandler = {
                            value: selectedDestination.address[0].id,
                            label: selectedDestination.address[0].company_name,
                            email: selectedDestination.address[0].handler_email_id,
                            address: selectedDestination.address[0].address,
                            number: selectedDestination.address[0].handler_phone_no,
                            id: selectedDestination.address[0].id,
                            hoid: selectedDestination.address[0].handler_org_id,
                        };
                        setSelectedOriginHandler(autoSelectedHandler);

                        setFormData(prevFormData => ({
                            ...prevFormData,
                            origin_handler_id: selectedDestination.address[0].id
                        }));
                    } else {
                        // Clear handler selection if multiple or no handlers
                        setSelectedOriginHandler(null);
                        setFormData(prevFormData => ({
                            ...prevFormData,
                            origin_handler_id: ''
                        }));
                    }
                }
                if (innerData.destination) {
                    const selectedDestination = getDestination.find(option => option.value === innerData.destination);
                    setDestinationHandler(selectedDestination ? selectedDestination.address : []);
                    setSelectedDestinationId(selectedDestination.station_id);

                    if (selectedDestination && selectedDestination.address.length === 1) {
                        const autoSelectedHandler = {
                            value: selectedDestination.address[0].id,
                            label: selectedDestination.address[0].company_name,
                            email: selectedDestination.address[0].handler_email_id,
                            address: selectedDestination.address[0].address,
                            number: selectedDestination.address[0].handler_phone_no,
                            id: selectedDestination.address[0].id,
                            hoid: selectedDestination.address[0].handler_org_id,
                        };
                        setSelectedDestinationHandler(autoSelectedHandler);

                        setFormData(prevFormData => ({
                            ...prevFormData,
                            destination_handler_id: selectedDestination.address[0].id
                        }));
                    } else {
                        // Clear handler selection if multiple or no handlers
                        setSelectedDestinationHandler(null);
                        setFormData(prevFormData => ({
                            ...prevFormData,
                            destination_handler_id: ''
                        }));
                    }
                }
            }

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const handleDetails = () => {
        localStorage.removeItem('RecoveryEdit');
        localStorage.setItem('RecoveryEdit', JSON.stringify(formData));
        history.push("/OverviewDetails");
    }
    const confModalCClose = () => {
        setFormData(initFData);
        setModalConf(false);
    }


    const [selectedStation, setSelectedStation] = useState({});
    const handleAddStation = () => {
        setStations([
            ...stations,
            { station: '', station_id: '', stationHandler: [], selectedDestinationHandler: null, notifyChecked: false }
        ]);
        setFormData(prevFormData => ({
            ...prevFormData,
            all_stations: [
                ...prevFormData.all_stations,
                { station_name: '', handler_id: '', notify_status: '0' } // Default notify_status to "0"
            ]
        }));
    };
    const handleDeleteStation = (index) => {
        // Remove from stations array
        setStations(prevStations => prevStations.filter((_, idx) => idx !== index));

        // Remove from formData.all_stations
        setFormData(prevFormData => {
            const updatedStations = prevFormData.all_stations.filter((_, idx) => idx !== index);
            return { ...prevFormData, all_stations: updatedStations };
        });
    };

    const handleStationChange = (index, selected, stationHandlers = null, autoSelectedHandler = null) => {
        const selectedDestination = getDestination.find(option => option.value === selected.value);

        setStations(prevStations =>
            prevStations.map((station, idx) =>
                idx === index
                    ? {
                        ...station,
                        station: selected.value,
                        station_id: selectedDestination.station_id,
                        stationHandler: stationHandlers || (selectedDestination ? selectedDestination.address : []),
                        selectedDestinationHandler: autoSelectedHandler
                    }
                    : station
            )
        );

        setFormData(prevFormData => {
            const updatedAllStations = [...prevFormData.all_stations];
            updatedAllStations[index] = {
                ...updatedAllStations[index],
                station_name: selected.value, // or selected.label if you want the name
                handler_id: autoSelectedHandler ? autoSelectedHandler.value : (updatedAllStations[index]?.handler_id || ''),
                type: 'Station',
                notify_status: updatedAllStations[index]?.notify_status || '0',
            };
            return { ...prevFormData, all_stations: updatedAllStations };
        });
    };

    const handleHandlerChange = (index, selected) => {
        setStations(prevStations =>
            prevStations.map((station, idx) =>
                idx === index
                    ? { ...station, selectedDestinationHandler: selected }
                    : station
            )
        );

        setFormData(prevFormData => {
            const updatedStations = [...prevFormData.all_stations];
            updatedStations[index] = {
                ...updatedStations[index],
                handler_id: selected.value
            };
            return { ...prevFormData, all_stations: updatedStations };
        });
    };


    // IMAGE UPLOAD START
    const [isTopDel, setIsTopDel] = useState(false);

    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
        getBase64(droppedFiles[0]);

    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDeleteFile = (index, id, type) => {
        if (isTopDel) {
            setEditFiles((prevFiles) => {
                const newFiles = [...prevFiles];
                newFiles.splice(index, 1);
                return newFiles;
            });
        } else {
            setFiles((prevFiles) => {
                const newFiles = [...prevFiles];
                newFiles.splice(index, 1);
                return newFiles;
            });
            // base64Files.splice(index, 1);
            setBase64Files((prevBase64Files) => {
                const newBase64Files = [...prevBase64Files];
                newBase64Files.splice(index, 1);

                // Update local storage
                setFormData((prevFormData) => {
                    const newFormData = { ...prevFormData, base64Files: newBase64Files, files: newBase64Files };
                    return newFormData;
                });

                return newBase64Files;
            });
        }

    };

    const handleBrowseFiles = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    };

    function getBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        const filesWithBase64 = [];
        let filesProcessed = 0;

        // const existingData = JSON.parse(localStorage.getItem(keyType)) || {};
        const existingBase64Files = formData?.base64Files || [];
        const existingFiles = formData?.files || [];

        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                filesWithBase64.push({ file, base64: reader.result, file_name: file.name });
                filesProcessed += 1;
                if (filesProcessed === selectedFiles.length) {
                    const newFiles = filesWithBase64.map((obj) => obj.file);
                    // const newBase64Files = filesWithBase64.map((obj) => obj.base64);
                    const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
                    const mergedBase64Files = [...existingBase64Files, ...newBase64Files];
                    const mergedFiles = [...existingFiles, ...newBase64Files];
                    // setFiles(newFiles);
                    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
                    setBase64Files(mergedBase64Files);
                    setFormData((prevFormData) => {
                        // const newFormData = { ...prevFormData, files: newFiles, base64Files: mergedBase64Files };
                        const newFormData = { ...prevFormData, files: mergedFiles, base64Files: mergedBase64Files };

                        return newFormData;
                    });
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handleDeleteImage = (index, id, type) => {
        setIsTopDel(true);
        handleDeleteFile(index);
        // setShowConfirmation(true); need to work
    };
    // IMAGE UPLOAD END

    // image select
    const [selectedKeys, setSelectedKeys] = useState([]);

    const handleImageSelect = (key, data) => {

        if (formData.files) {
            const extension = data?.name?.split('.').pop().toLowerCase();
            if (["jpeg", "jpg", "png", "webp"].includes(extension)) {
                setFormData((prevFormData) => {
                    const updatedFiles = prevFormData.files.map((file, index) => {
                        if (index === key) {
                            // Toggle the "primary" field for the selected file
                            return {
                                ...file,
                                primary: file.primary === 1 ? 0 : 1,
                            };
                        }
                        return file;
                    });

                    return {
                        ...prevFormData,
                        files: updatedFiles,
                    };
                });

                setSelectedKeys((prevSelected) =>
                    prevSelected.includes(key)
                        ? prevSelected.filter((selectedKey) => selectedKey !== key) // Remove key if already selected
                        : [...prevSelected, key] // Add key if not selected
                );
            }
        }
        if (["jpeg", "jpg", "png", "webp"].includes(data?.file_type)) {

            setEditFiles((prevFiles) =>
                prevFiles.map((file) =>
                    file.id === data.id
                        ? { ...file, primary: file.primary === 1 ? 0 : 1 } // Toggle primary between 1 and 0
                        : file // Leave other files unchanged
                )
            );
        }

    };

    // ADDRESS MODAL
    const addressModalOpen = (addressType, slst) => {
        fetchAddressData(addressType, slst)
        if (addressType == 'RH') {
            setInputAddress({
                handler_org_id: selectedReportHandler.hoid,
                address: selectedReportHandler.address,
                // handler_email_id: selectedOriginHandler.email,
                handler_email_id: Array.isArray(selectedReportHandler.email) && selectedReportHandler.email.length === 0 ? [''] : selectedReportHandler.email,
                handler_phone_no: selectedReportHandler.number,
                handler_contact_id: selectedReportHandler?.id,
            });
        } else if (addressType == 'OH') {
            setInputAddress({
                handler_org_id: selectedOriginHandler.hoid,
                address: selectedOriginHandler.address,
                // handler_email_id: selectedOriginHandler.email,
                handler_email_id: Array.isArray(selectedOriginHandler.email) && selectedOriginHandler.email.length === 0 ? [''] : selectedOriginHandler.email,
                handler_phone_no: selectedOriginHandler.number,
                handler_contact_id: selectedOriginHandler?.id,
            });
        } else if (addressType == 'DH') {
            setInputAddress({
                handler_org_id: selectedDestinationHandler.hoid,
                address: selectedDestinationHandler.address,
                // handler_email_id: selectedDestinationHandler.email,
                handler_email_id: Array.isArray(selectedDestinationHandler.email) && selectedDestinationHandler.email.length === 0 ? [''] : selectedDestinationHandler.email,
                handler_phone_no: selectedDestinationHandler.number,
                handler_contact_id: selectedDestinationHandler?.id,
            });
        } else if (addressType == 'SH') {
            setInputAddress({
                handler_org_id: slst?.hoid,
                address: slst?.address,
                // handler_email_id: slst?.email,
                handler_email_id: Array.isArray(slst?.email) && slst?.email.length === 0 ? [''] : slst?.email,
                handler_phone_no: slst?.number,
                handler_contact_id: slst?.id,
            });
        }
        setSelectedStation(slst);
        setAddressFor(addressType);
        setAddressModalShow(true);
    }
    let repLabel;
    if (selectedReportId) {
        const idMatch = getDestination.find(option => option.station_id == selectedReportId);
        repLabel = idMatch.label;
    }
    let orgLabel;
    if (selectedOriginId) {
        const idMatch = getDestination.find(option => option.station_id == selectedOriginId);
        orgLabel = idMatch.label;
    }
    let destLabel;
    if (selectedDestinationId) {
        const idMatch = getDestination.find(option => option.station_id == selectedDestinationId);
        destLabel = idMatch.label;
    }
    const handleAddressChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (type === 'checkbox' && name === 'regd') {
            setInputAddress({ ...inputAddress, [name]: checked ? '1' : '0' });
        } else {
            setInputAddress({ ...inputAddress, [name]: value });
        }
        console.log(inputAddress);
    };

    // Email array start
    const handleEmailChange = (index, value) => {
        setInputAddress((prev) => {
            const updatedEmails = [...prev.handler_email_id];
            updatedEmails[index] = value;
            return { ...prev, handler_email_id: updatedEmails };
        });
    };

    const addEmailField = () => {
        setInputAddress((prev) => ({
            ...prev,
            handler_email_id: [...prev.handler_email_id, '']
        }));
    };

    const removeEmailField = (index) => {
        setInputAddress((prev) => ({
            ...prev,
            handler_email_id: prev.handler_email_id.filter((_, i) => i !== index)
        }));
    };
    // Email array end

    const validateAddressData = () => {
        let isValid = true;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        // Function to validate email
        const validateEmail = (email) => {
            return emailRegex.test(email);
        };
        if (!inputAddress.handler_org_id) {
            toast.error('Please select a Handler name');
            isValid = false;
        }
        // else if (!validateEmail(inputAddress.handler_email_id)) {
        //     toast.error('Please enter valid email address');
        //     isValid = false;
        // }
        else {
            return isValid;
        }
    };

    const addAddress = async (e) => {
        // console.log('444', inputAddress);
        if (validateAddressData()) {
            e.preventDefault();

            let stationid;
            if (addressFor == 'report' || addressFor == 'RH') {
                stationid = selectedReportId;
            } else if (addressFor == 'origin' || addressFor == 'OH') {
                stationid = selectedOriginId;
            } else if (addressFor == 'destination' || addressFor == 'DH') {
                stationid = selectedDestinationId;
            } else {
                stationid = selectedStation.station_id
            }
            const transformedEmails = inputAddress.handler_email_id.filter(email => email.trim() !== '');
            const NewInputAddress = { ...inputAddress, handler_email_id: transformedEmails, station_id: stationid };
            if (NewInputAddress) {
                try {
                    const res = await withRFSToken.post(SAVEHANDLER, NewInputAddress)
                        .then(function (res) {
                            // const innerData = res;
                            if (res.data.response_code == 200) {
                                toast.success(res.data.response_msg);
                                const newAddress = res.data.response_data;
                                setAddress(newAddress);
                                // fetchStationData();
                                fetchStationData();
                                if (addressFor === 'origin' || addressFor === 'destination') {

                                }
                                if (addressFor == 'origin') {
                                    setOriginHandler(prevHandlerNames => [
                                        ...prevHandlerNames,
                                        newAddress
                                    ]);
                                    // setTimeout(() => {
                                    //     if (originHandler.length === 1) {
                                    //         setSelectedOriginHandler({ value: newAddress.id, label: newAddress.company_name })
                                    //     }
                                    // }, 500);
                                } else if (addressFor == 'destination') {
                                    setDestinationHandler(prevHandlerNames => [
                                        ...prevHandlerNames,
                                        newAddress
                                    ]);
                                } else if (addressFor == 'OH') {
                                    const transformData = {
                                        value: newAddress?.id,
                                        label: newAddress?.company_name,
                                        email: newAddress?.handler_email_id,
                                        address: newAddress?.address,
                                        number: newAddress?.handler_phone_no,
                                        id: newAddress?.handler_contact_id,
                                        hoid: newAddress?.handler_org_id,
                                    }
                                    setSelectedOriginHandler(transformData);
                                } else if (addressFor == 'DH') {
                                    const transformData = {
                                        value: newAddress?.id,
                                        label: newAddress?.company_name,
                                        email: newAddress?.handler_email_id,
                                        address: newAddress?.address,
                                        number: newAddress?.handler_phone_no,
                                        id: newAddress?.handler_contact_id,
                                        hoid: newAddress?.handler_org_id,
                                    }
                                    setSelectedDestinationHandler(transformData);
                                } else if (addressFor == 'SH') {

                                    const transformData = {
                                        value: newAddress?.id,
                                        label: newAddress?.company_name,
                                        email: newAddress?.handler_email_id,
                                        address: newAddress?.address,
                                        number: newAddress?.handler_phone_no,
                                        id: newAddress?.handler_contact_id,
                                        hoid: newAddress?.handler_org_id,
                                        station_id: newAddress?.station_id
                                    }
                                    // console.log('transformData=1', transformData);
                                    // setSelectedStation(transformData);
                                    setStations(prevStations =>
                                        prevStations.map(station =>
                                            station.station_id === selectedStation.station_id
                                                ? {
                                                    ...station,
                                                    selectedDestinationHandler: transformData, // Update stationHandler with newAddress data
                                                    stationHandler: station.stationHandler.map(handler =>
                                                        handler.handler_org_id === newAddress.handler_org_id
                                                            ? { ...handler, ...newAddress } // Replace the matched handler with newAddress
                                                            : handler // Keep the other handlers unchanged
                                                    ),
                                                }
                                                : station
                                        )
                                    );
                                } else {
                                    // const stnHandler = stations?.find(name => name.station === selectedStation.station);

                                    setStations(prevStations =>
                                        prevStations.map(station =>
                                            station.station === selectedStation.station
                                                ? {
                                                    ...station,
                                                    stationHandler: [...station.stationHandler, newAddress] // Update stationHandler with newAddress data
                                                }
                                                : station
                                        )
                                    );
                                }
                                setInputAddress({
                                    handler_org_id: '', address: '', handler_email_id: [''], handler_phone_no: ''
                                });
                                // console.log(address);
                                addressModalClose();
                            } else {
                                toast.error(res.data.response_msg);
                            }
                        });

                } catch (error) {
                    console.error('Error sending request:', error);
                }
            }
        }
    }
    // ADDRESS MODAL END
    const [modalConf, setModalConf] = useState(false);
    const [confData, setConfData] = useState({});
    const validateFormData = () => {
        let isValid = true;

        const prefix = String(formData.master_airway_bill_prefix || "");
        console.log('prefix', prefix);

        const number = String(formData.master_airway_bill_no || "");

        if (prefix.length !== 3) {
            toast.error('Invalid Master Airway Bill');
            isValid = false;
        } else if (number.length !== 9) {
            toast.error('Invalid Master Airway Bill');
        } else if (!formData.flight_prefix) {
            toast.error('Insert Flight Code');
        } else if (!formData.flight_no) {
            toast.error('Insert Flight Number');
        } else if (!formData.flight_date) {
            toast.error('Insert Flight Date');
        } else if (!formData.origin) {
            toast.error('Insert Origin');
        } else if (!formData.destination) {
            toast.error('Insert Destination');
        }
        // else if (!formData.origin_handler_id) {
        //     toast.error('Insert Origin Handler');
        // } else if (!formData.destination_handler_id) {
        //     toast.error('Insert Destination Handler');
        // } 
        else if (!formData.total_mawb_pieces) {
            toast.error('Insert Total MAWB Pieces');
        } else if (!formData.total_mawb_wght) {
            toast.error('Insert Total MAWB Weight');
        } else if (!formData.pieces_involved) {
            toast.error('Insert Pieces Involve');
        } else if (!formData.pieces_wght) {
            toast.error('Insert Weight Involved');
        } else if (!formData.recovery_aspects.length > 0) {
            toast.error('Insert Recovery Aspects');
        }
        else {
            return isValid;
        }
    }

    const confModalClose = () => {
        setModalConf(false);
    }

    const checkFinish = () => {
        if (validateFormData()) {

            const missingFields = [];
            if (!formData.origin_handler_id) missingFields.push('Origin Handler');
            if (!formData.destination_handler_id) missingFields.push('Destination Handler');
            if (missingFields.length > 0) {

                const missingText =
                    missingFields.length === 1
                        ? missingFields[0]
                        : `${missingFields[0]} and ${missingFields[1]}`;

                setConfData({
                    header: `Missing Handlers`,
                    subHeader: `Saving without ${missingText}`,
                    modalConf: { handleFinish },
                    closeModal: { confModalClose },
                    primaryBtn: 'Continue',
                    secondaryBtn: 'Cancel',
                })
                setModalConf(true)
            } else {
                handleFinish()
            }
        }
    }
    const handleFinish = async () => {

        setDisLoading(true);
        // let transformedData;
        // if (localStorage.getItem('RecoveryEdit')) {

        // } else {
        const filterPrimary = editFiles?.filter(file => file.primary === 1);
        const restFiles = editFiles?.filter((file) => !file.primary || file.primary !== 1);
        const transformedData = {
            ...formData,
            report_notify_status: formData.report_notify_status == true ? 1 : 0,
            origin_notify_status: formData.origin_notify_status == true ? 1 : 0,
            destination_notify_status: formData.origin_notify_status == true ? 1 : 0,
            all_stations: [
                // {
                //     station_name: formData.reported_station,
                //     type: 'Reported',
                //     handler_id: formData.report_handler_id ? formData.report_handler_id : '',
                //     notify_status: formData.report_notify_status == true ? 1 : 0
                // },
                {
                    station_name: formData.origin,
                    type: 'Origin',
                    handler_id: formData.origin_handler_id ? formData.origin_handler_id : '',
                    notify_status: formData.origin_notify_status == true ? 1 : 0
                },
                {
                    station_name: formData.destination,
                    type: 'Destination',
                    handler_id: formData.destination_handler_id ? formData.destination_handler_id : '',
                    notify_status: formData.destination_notify_status == true ? 1 : 0
                },
                ...formData.all_stations
            ],
            files: [
                ...(formData.files || []),
                ...filterPrimary.map((file) => ({ id: file.id, primary: file.primary })),
                ...restFiles.map((file) => ({ id: file.id, primary: 0 })),
            ]
        };
        // }
        try {
            const res = await withRFSToken.post(SAVERECOVERY, transformedData)
                .then(function (res) {
                    setDisLoading(false);
                    if (res.data.response_code == 200) {
                        toast.success(res.data.response_msg);
                        onSubmit()
                        closeserviceRecovery()
                        // setTimeout(() => {
                        // window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
                        // window.location.href = '/ServiceRecovery';
                        // }, 1000);
                    } else {
                        toast.error(res.data.response_msg);
                    }
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const closeserviceRecovery = () => {
        setServiceRecoveryShow(false);
        setFormData({ all_stations: [], origin_notify_status: 1, destination_notify_status: 1 });
        setOriginHandler([])
        setDestinationHandler([])
        setSelectedOriginHandler(null)
        setSelectedDestinationHandler(null)
        setFiles([])
        onClose()
    };

    return (
        <>
            {modalConf &&
                <ConfModal
                    header={confData.header}
                    subHeader={confData.subHeader}
                    modalConf={confData.modalConf === 'C' ? handleDetails : handleFinish}
                    closeModal={confData.modalConf === 'C' ? confModalCClose : confModalClose}
                    primaryBtn={confData.primaryBtn}
                    secondaryBtn={confData.secondaryBtn}
                />
            }
            {console.log('formData', formData)}
            <Modal show={serviceRecoveryShow} centered className="addfrom add_recovery_modal" size='xl'> {/* onHide={closeserviceRecovery} */}
                <Modal.Header closeButton onClick={closeserviceRecovery}>
                    <ModalTitle> Add Recovery </ModalTitle>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col lg={6} className='mb-3 left_part'>
                            <div className=''>
                                <div className='ship_head'>
                                    <h4>Recovery Information</h4>
                                </div>
                                <Form className=''>
                                    <div className='d-flex mb-2 align-items-center'>
                                        <Form.Label>Master Airway Bill <span>*</span></Form.Label>
                                        <Form.Control
                                            type="number"
                                            placeholder=""
                                            name='master_airway_bill_prefix'
                                            onChange={handleInputChange}
                                            maxLength='3'
                                            onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 3); }}
                                            value={formData?.master_airway_bill_prefix || ''}
                                            className='awbnum'
                                        />

                                        <span> - </span>

                                        <Form.Control
                                            type="text"
                                            placeholder=""
                                            name='master_airway_bill_no'
                                            maxLength={9}
                                            onChange={handleInputChange}
                                            value={formData?.master_airway_bill_no || ''}
                                            className='add_hifen me-3'

                                        />
                                        <Form.Label style={{ width: 'auto' }} className='me-2'>CUS <span></span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder=""
                                            name='cus'
                                            maxLength={9}
                                            onChange={handleInputChange}
                                            value={formData?.cus || ''}
                                            className='add_hifen'

                                        />
                                    </div>
                                    <div className='d-flex mb-4 align-items-center'>
                                        <Form.Label>Nature of goods<span></span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder=""
                                            name='nature_of_goods'
                                            maxLength={9}
                                            onChange={handleInputChange}
                                            value={formData?.nature_of_goods || ''}
                                            className='add_hifen me-3'

                                        />
                                        <Form.Label style={{ width: 'auto' }} className='me-2'>SHC <span></span></Form.Label>
                                        <Select
                                            options={getShc}
                                            value={getShc.filter(item => formData?.shc_id?.includes(item.value))}
                                            onChange={(selected) => {
                                                const selectedIds = selected.map(item => item.value);
                                                setFormData((prevFormData) => ({
                                                    ...prevFormData,
                                                    shc_id: selectedIds
                                                }));
                                            }}
                                            labelledBy="Select "
                                            isMulti
                                            className='multiselect_brd add_shc'
                                        />
                                    </div>
                                    <div className='d-flex mb-2 align-items-center'>
                                        <Form.Label>Flight <span>*</span></Form.Label>
                                        {/* <Form.Control type="text" placeholder="" /> */}
                                        <Select
                                            options={getOwnerCodes}
                                            onChange={(selected) => {
                                                // const updatedData = { ...formData, flight: selected.value };
                                                // setFormData(updatedData);
                                                setFormData(prevFormData => {
                                                    const newFormData = { ...prevFormData, flight_prefix: selected.value };
                                                    return newFormData;
                                                });
                                            }}
                                            placeholder="Flight"
                                            className='autoslct w-50 p-0 me-2'
                                            name="flight_prefix"
                                            value={getOwnerCodes.find(option => option.value === formData.flight_prefix) || ''}

                                        />
                                        <Form.Control
                                            type="text"
                                            name='flight_no'
                                            maxLength='8'
                                            onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 8); }}
                                            value={formData.flight_no || ''}
                                            onChange={handleInputChange}

                                        />
                                    </div>

                                    <div className='d-flex mb-4 align-items-center'>
                                        <Form.Label>Flight Date <span>*</span></Form.Label>
                                        <Form.Control
                                            placeholder=""
                                            type="date"
                                            name="flight_date"
                                            value={formData.flight_date || ''}
                                            onChange={handleInputChange}
                                        />
                                    </div>

                                    {/* <div className='d-flex mb-2 align-items-center align-items-center'>
                                        <label className="form-label">Reporting Handler Name <span></span></label>
                                        <Select
                                            options={reportHandler?.map(handler => ({
                                                value: handler?.id,
                                                label: handler?.company_name,
                                                email: handler?.handler_email_id,
                                                address: handler?.address,
                                                number: handler?.handler_phone_no,
                                                id: handler?.id,
                                                hoid: handler?.handler_org_id,
                                            }))}
                                            onChange={(selected) => {
                                                // const updatedData = { ...formData, origin_handler: selected.label };
                                                // setFormData(updatedData);
                                                setSelectedReportHandler(selected);
                                                setFormData(prevFormData => {
                                                    const newFormData = { ...prevFormData, report_handler_id: selected.value };
                                                    // const keyData = JSON.parse(localStorage.getItem(keyType)) || { Form: {} };
                                                    // keyData.Form = newFormData;
                                                    // localStorage.setItem(keyType, JSON.stringify(keyData));

                                                    return newFormData;
                                                });
                                            }}
                                            placeholder="Handler Name"
                                            className='autoslct w-100 p-0'
                                            name="report_handler_id"
                                            // value={handlerNames.find(option => option.value === (selectedHandler ? selectedHandler.value : ''))}
                                            value={selectedReportHandler ? { value: selectedReportHandler.value, label: selectedReportHandler.label } : ''}
                                            isDisabled={!reportHandler.length}
                                        />
                                        <div className='raad_adrss'>
                                            {formData.reported_station ? <Link to='#' onClick={() => addressModalOpen('report')}>+Add</Link> : ''}
                                        </div>
                                        <div className='mail_adrss'>
                                            {selectedReportHandler &&
                                                <>
                                                    {selectedReportHandler?.email.some((e) => e.trim() !== "") ?
                                                        <><Link to='#' onClick={() => addressModalOpen('RH')}><img src={MailGreen} /></Link></>
                                                        : <><Link to='#' onClick={() => addressModalOpen('RH')}><img src={MailRed} /></Link></>
                                                    }
                                                </>
                                            }
                                        </div>
                                    </div> */}

                                    <div className='d-flex mb-2 align-items-center'>
                                        <Form.Label>Origin <span>*</span></Form.Label>
                                        <Select
                                            options={getDestination}
                                            onChange={(selected) => {
                                                const selectedDestination = getDestination.find(option => option.value === selected.value);
                                                const transHandler = [{ company_name: 'Select Handler', id: null }, ...selectedDestination.address]
                                                setOriginHandler(selectedDestination ? transHandler : []);
                                                setSelectedOriginId(selectedDestination.station_id);

                                                if (selectedDestination && selectedDestination.address.length === 1) {
                                                    const autoSelectedHandler = {
                                                        value: selectedDestination.address[0].id,
                                                        label: selectedDestination.address[0].company_name,
                                                        email: selectedDestination.address[0].handler_email_id,
                                                        address: selectedDestination.address[0].address,
                                                        number: selectedDestination.address[0].handler_phone_no,
                                                        id: selectedDestination.address[0].id,
                                                        hoid: selectedDestination.address[0].handler_org_id,
                                                    };
                                                    setSelectedOriginHandler(autoSelectedHandler);

                                                    setFormData(prevFormData => ({
                                                        ...prevFormData,
                                                        origin: selected.value,
                                                        origin_handler_id: selectedDestination.address[0].id
                                                    }));
                                                } else {
                                                    // Clear handler selection if multiple or no handlers
                                                    setSelectedOriginHandler(null);
                                                    setFormData(prevFormData => ({
                                                        ...prevFormData,
                                                        origin: selected.value,
                                                        origin_handler_id: ''
                                                    }));
                                                }
                                            }}
                                            placeholder="Origin"
                                            className='autoslct w-100 p-0'
                                            name="origin"
                                            value={getDestination.find(option => option.value === formData.origin) || ''}
                                        />
                                    </div>
                                    <div className='d-flex mb-2 align-items-center align-items-center'>
                                        <label className="form-label">Origin Handler Name <span></span></label>
                                        <Select
                                            options={originHandler?.map(handler => ({
                                                value: handler?.id,
                                                label: handler?.company_name,
                                                email: handler?.handler_email_id,
                                                address: handler?.address,
                                                number: handler?.handler_phone_no,
                                                id: handler?.id,
                                                hoid: handler?.handler_org_id,
                                            }))}
                                            onChange={(selected) => {
                                                // const updatedData = { ...formData, origin_handler: selected.label };
                                                // setFormData(updatedData);
                                                setSelectedOriginHandler(selected);
                                                setFormData(prevFormData => {
                                                    const newFormData = { ...prevFormData, origin_handler_id: selected.value };
                                                    // const keyData = JSON.parse(localStorage.getItem(keyType)) || { Form: {} };
                                                    // keyData.Form = newFormData;
                                                    // localStorage.setItem(keyType, JSON.stringify(keyData));

                                                    return newFormData;
                                                });
                                            }}
                                            placeholder="Handler Name"
                                            className='autoslct w-100 p-0'
                                            name="origin_handler_id"
                                            // value={handlerNames.find(option => option.value === (selectedHandler ? selectedHandler.value : ''))}
                                            value={selectedOriginHandler ? { value: selectedOriginHandler.value, label: selectedOriginHandler.label } : ''}
                                            isDisabled={!originHandler.length}
                                        />
                                        <div className='raad_adrss'>
                                            {formData.origin ? <Link to='#' onClick={() => addressModalOpen('origin')}>+Add</Link> : ''}
                                        </div>
                                        <div className='mail_adrss'>
                                            {selectedOriginHandler?.email ?
                                                <>
                                                    {selectedOriginHandler?.email.some((e) => e.trim() !== "") ?
                                                        <><Link to='#' onClick={() => addressModalOpen('OH')}><img src={MailGreen} /></Link></>
                                                        : <><Link to='#' onClick={() => addressModalOpen('OH')}><img src={MailRed} /></Link></>
                                                    }
                                                </>
                                                : <></>
                                            }
                                        </div>
                                    </div>
                                    <div className='d-flex mb-2 align-items-center'>
                                        <Form.Label>Destination <span>*</span></Form.Label>
                                        <Select
                                            column sm="8"
                                            options={getDestination}
                                            onChange={(selected) => {
                                                const selectedDestination = getDestination.find(option => option.value === selected.value);
                                                const transHandler = [{ company_name: 'Select Handler', id: null }, ...selectedDestination.address]
                                                setDestinationHandler(selectedDestination ? transHandler : []);
                                                setSelectedDestinationId(selectedDestination.station_id);

                                                if (selectedDestination && selectedDestination.address.length === 1) {
                                                    const autoSelectedHandler = {
                                                        value: selectedDestination.address[0].id,
                                                        label: selectedDestination.address[0].company_name,
                                                        email: selectedDestination.address[0].handler_email_id,
                                                        address: selectedDestination.address[0].address,
                                                        number: selectedDestination.address[0].handler_phone_no,
                                                        id: selectedDestination.address[0].id,
                                                        hoid: selectedDestination.address[0].handler_org_id,
                                                    };
                                                    setSelectedDestinationHandler(autoSelectedHandler);

                                                    setFormData(prevFormData => ({
                                                        ...prevFormData,
                                                        destination: selected.value,
                                                        destination_handler_id: selectedDestination.address[0].id
                                                    }));
                                                } else {
                                                    // Clear handler selection if multiple or no handlers
                                                    setSelectedDestinationHandler(null);
                                                    setFormData(prevFormData => ({
                                                        ...prevFormData,
                                                        destination: selected.value,
                                                        destination_handler_id: ''
                                                    }));
                                                }
                                            }}
                                            placeholder="Destination"
                                            className='autoslct w-100 p-0'
                                            name="destination"
                                            value={getDestination.find(option => option.value === formData.destination) || ''}
                                        />
                                    </div>
                                    <div className='d-flex mb-2 align-items-center '>
                                        <label className="form-label">Destination Handler Name <span></span> </label>
                                        <Select
                                            options={destinationHandler.map(handler => ({
                                                value: handler?.id,
                                                label: handler?.company_name,
                                                email: handler?.handler_email_id,
                                                address: handler?.address,
                                                number: handler?.handler_phone_no,
                                                id: handler?.id,
                                                hoid: handler?.handler_org_id,
                                            }))}
                                            onChange={(selected) => {
                                                // const updatedData = { ...formData, destination_handler: selected.label };
                                                // setFormData(updatedData);
                                                setSelectedDestinationHandler(selected);
                                                setFormData(prevFormData => {
                                                    const newFormData = { ...prevFormData, destination_handler_id: selected.value };
                                                    // const keyData = JSON.parse(localStorage.getItem(keyType)) || { Form: {} };
                                                    // keyData.Form = newFormData;
                                                    // localStorage.setItem(keyType, JSON.stringify(keyData));

                                                    return newFormData;
                                                });
                                            }}
                                            placeholder="Handler Name"
                                            className='autoslct w-100 p-0'
                                            name="destination_handler_id"
                                            // value={handlerNames.find(option => option.value === (selectedHandler ? selectedHandler.value : ''))}
                                            value={selectedDestinationHandler ? { value: selectedDestinationHandler.value, label: selectedDestinationHandler.label } : ''}
                                            isDisabled={!destinationHandler.length}
                                        />
                                        <div className='raad_adrss'>
                                            {formData.destination ? <Link to='#' onClick={() => addressModalOpen('destination')}>+Add</Link> : ''}
                                        </div>
                                        <div className='mail_adrss'>
                                            {selectedDestinationHandler?.email ?
                                                <>
                                                    {selectedDestinationHandler?.email.some((e) => e.trim() !== "") ?
                                                        <><Link to='#' onClick={() => addressModalOpen('DH')}><img src={MailGreen} /></Link></>
                                                        : <><Link to='#' onClick={() => addressModalOpen('DH')}><img src={MailRed} /></Link></>
                                                    }
                                                </>
                                                : <></>
                                            }
                                        </div>
                                    </div>
                                    {stations.map((station, index) => (
                                        <div key={index}>
                                            <Form.Group as={Row} className="my-3 add_station position-relative">
                                                <Col sm="4" className='pe-0'>
                                                    <Form.Label>Station <span>*</span></Form.Label>
                                                    {/* <Select
                                                        options={getDestination}
                                                        onChange={(selected) => handleStationChange(index, selected)}
                                                        placeholder="Destination"
                                                        className='autoslct w-100 p-0'
                                                        name={`station-${index}`}
                                                        value={getDestination.find(option => option.value === station.station) || ''}
                                                    /> */}
                                                    <Select
                                                        options={getDestination}
                                                        onChange={(selected) => {
                                                            const selectedStation = getDestination.find(option => option.value === selected.value);

                                                            if (selectedStation && selectedStation.address.length === 1) {
                                                                const autoSelectedHandler = {
                                                                    value: selectedStation.address[0].id,
                                                                    label: selectedStation.address[0].company_name,
                                                                    email: selectedStation.address[0].handler_email_id,
                                                                    address: selectedStation.address[0].address,
                                                                    number: selectedStation.address[0].handler_phone_no,
                                                                    id: selectedStation.address[0].id,
                                                                    hoid: selectedStation.address[0].handler_org_id,
                                                                    station_id: selectedStation.address[0].station_id
                                                                };

                                                                handleStationChange(index, selected, selectedStation.address, autoSelectedHandler);
                                                            } else {

                                                                handleStationChange(index, selected, selectedStation ? selectedStation.address : []);
                                                            }
                                                        }}
                                                        placeholder="Destination"
                                                        className='autoslct w-100 p-0'
                                                        name={`station-${index}`}
                                                        value={getDestination.find(option => option.value === station.station) || ''}
                                                    />
                                                </Col>
                                                <Col sm="6" className='pe-0'>
                                                    <label className="form-label"> Station Handler Name <span></span>
                                                        {/* {station.station ? (
                                                            <Link to='#' onClick={() => addressModalOpen('station', station)} className='raad_adrss'>+ Add</Link>
                                                        ) : ''} */}
                                                    </label>
                                                    <Select
                                                        options={station.stationHandler.map(handler => ({
                                                            value: handler.id,
                                                            label: handler.company_name,
                                                            email: handler?.handler_email_id,
                                                            address: handler?.address,
                                                            number: handler?.handler_phone_no,
                                                            id: handler?.id,
                                                            hoid: handler?.handler_org_id,
                                                            station_id: handler?.station_id
                                                        }))}
                                                        onChange={(selected) => handleHandlerChange(index, selected)}
                                                        placeholder="Handler Name"
                                                        className='autoslct w-100 p-0'
                                                        name={`station_handler-${index}`}
                                                        value={station.selectedDestinationHandler ? { value: station.selectedDestinationHandler.value, label: station.selectedDestinationHandler.label } : ''}
                                                        isDisabled={!station.stationHandler.length}
                                                    />
                                                </Col>
                                                <Col sm="2" className='align-self-center mt-20 pe-0'>
                                                    {station.station ? (
                                                        <Link to='#' onClick={() => addressModalOpen('station', station)} className='raad_adrss me-2'>+ Add</Link>
                                                    ) : ''}
                                                    {station.selectedDestinationHandler &&
                                                        <>
                                                            {station.selectedDestinationHandler?.email.some((e) => e.trim() !== "") ?
                                                                <><Link to='#' onClick={() => addressModalOpen('SH', station.selectedDestinationHandler)}><img src={MailGreen} /></Link></>
                                                                : <><Link to='#' onClick={() => addressModalOpen('SH', station.selectedDestinationHandler)}><img src={MailRed} /></Link></>
                                                            }
                                                        </>
                                                    }
                                                </Col>

                                                <Link to="#" onClick={() => handleDeleteStation(index)} className='recovery_trash'>
                                                    <img src={Trash} />
                                                </Link>
                                            </Form.Group>
                                        </div>
                                    ))}
                                    <Button variant="outline-primary" className='more_btn mt-3' onClick={handleAddStation}>
                                        Add More Station's
                                    </Button>
                                </Form>
                            </div>
                        </Col>
                        {/* Incident Info */}
                        <Col lg={6} className='mb-3'>
                            <div className=''>
                                <div className='ship_head'>
                                    <h4>Incident Information</h4>
                                </div>
                                <div className='d-flex mb-2 align-items-center'>
                                    <Form.Label>Reporting Station <span></span></Form.Label>
                                    <Select
                                        options={getDestination}
                                        // onChange={(selected) => {
                                        //     setFormData(prevFormData => ({
                                        //         ...prevFormData,
                                        //         reported_station: selected.value,
                                        //     }));
                                        // }}
                                        onChange={(selected) => {
                                            const selectedDestination = getDestination.find(option => option.value === selected.value);
                                            setReportHandler(selectedDestination ? selectedDestination.address : []);
                                            setSelectedReportId(selectedDestination.station_id);

                                            if (selectedDestination && selectedDestination.address.length === 1) {
                                                const autoSelectedHandler = {
                                                    value: selectedDestination.address[0].id,
                                                    label: selectedDestination.address[0].company_name,
                                                    email: selectedDestination.address[0].handler_email_id,
                                                    address: selectedDestination.address[0].address,
                                                    number: selectedDestination.address[0].handler_phone_no,
                                                    id: selectedDestination.address[0].id,
                                                    hoid: selectedDestination.address[0].handler_org_id,
                                                };
                                                setSelectedReportHandler(autoSelectedHandler);

                                                setFormData(prevFormData => ({
                                                    ...prevFormData,
                                                    reported_station: selected.value,
                                                    report_handler_id: selectedDestination.address[0].id
                                                }));
                                            } else {
                                                // Clear handler selection if multiple or no handlers
                                                setSelectedReportHandler(null);
                                                setFormData(prevFormData => ({
                                                    ...prevFormData,
                                                    reported_station: selected.value,
                                                    report_handler_id: ''
                                                }));
                                            }
                                        }}
                                        placeholder="Reporting Station"
                                        className='autoslct w-100 p-0'
                                        name="reported_station"
                                        value={getDestination.find(option => option.value === formData.reported_station) || ''}
                                        isDisabled
                                    />
                                </div>
                                <Form className=''>
                                    <Row>
                                        <Col>
                                            <div className='d-flex mb-2 align-items-center'>
                                                <Form.Label>Total MAWB Pieces <span>*</span></Form.Label>
                                                <Form.Control

                                                    type="number"
                                                    name='total_mawb_pieces'
                                                    value={formData.total_mawb_pieces || ''}
                                                    onChange={handleInputChange}
                                                    className='total_pic'

                                                />
                                            </div>
                                        </Col>
                                        <Col>
                                            <div className='d-flex mb-2 align-items-center'>
                                                <Form.Label  >Weight (Kg) <span>*</span></Form.Label>
                                                <Form.Control

                                                    type="number"
                                                    name='total_mawb_wght'
                                                    value={formData.total_mawb_wght || ''}
                                                    onChange={handleInputChange}
                                                    className='total_pic'
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col>
                                            <div className='d-flex mb-2 align-items-center'>
                                                <Form.Label>Pieces involved <span>*</span></Form.Label>
                                                <Form.Control

                                                    type="number"
                                                    name='pieces_involved'
                                                    value={formData.pieces_involved || ''}
                                                    onChange={handleInputChange}
                                                    className='total_pic'
                                                />
                                            </div>
                                        </Col>
                                        <Col>
                                            <div className='d-flex mb-2 align-items-center'>
                                                <Form.Label  >Involved Weight (Kg) <span>*</span></Form.Label>
                                                <Form.Control

                                                    type="number"
                                                    name='pieces_wght'
                                                    value={formData.pieces_wght || ''}
                                                    onChange={handleInputChange}
                                                    className='total_pic'
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                    <div className='d-flex mb-2 align-items-center recover_ascp'>

                                        <Form.Label>Recovery Aspects <span>*</span></Form.Label>
                                        {/* {['MSCA', 'FDCA', 'DMA'].map(option => (
                                            <Form.Check
                                                key={option}
                                                inline
                                                type="checkbox"
                                                label={option}
                                                value={option}
                                                name='recovery_aspects'
                                                onChange={handleInputChange}
                                                checked={formData?.recovery_aspects?.includes(option)}

                                            />
                                        ))} */}
                                        <MultiSelect
                                            options={recoveryAspects}
                                            value={recoveryAspects.filter(item => formData.recovery_aspects?.includes(item.value))}
                                            onChange={(selected) => {
                                                const selectedIds = selected.map(item => item.value);
                                                setFormData((prevFormData) => ({
                                                    ...prevFormData,
                                                    recovery_aspects: selectedIds
                                                }));
                                            }}
                                            labelledBy="Select "
                                            className='multiselect w-100'
                                        />
                                    </div>
                                    {formData?.recovery_aspects?.includes(126) &&
                                        <div className='d-flex mb-2 align-items-start recover_ascp'>
                                            <Form.Label >Other Aspect</Form.Label>
                                            <MultiSelect
                                                options={otherAspects}
                                                value={otherAspects.filter(item => formData.recovery_aspects_others?.includes(item.value))}
                                                onChange={(selected) => {
                                                    const selectedIds = selected.map(item => item.value);
                                                    setFormData((prevFormData) => ({
                                                        ...prevFormData,
                                                        recovery_aspects_others: selectedIds
                                                    }));
                                                }}
                                                labelledBy="Select "
                                                className='multiselect w-100'
                                            />
                                            {/* <Form.Control as="text" name='recovery_aspects_others' rows={8} onChange={handleInputChange} value={formData.recovery_aspects_others} /> */}
                                        </div>
                                    }
                                    <div className='d-flex mb-2 align-items-start recover_ascp'>
                                        <Form.Label >Remarks</Form.Label>
                                        <Form.Control as="textarea" name='comment' rows={8} onChange={handleInputChange} value={formData.comment} />
                                    </div>
                                    <div className=''>
                                        <div>
                                            <Form.Label className='mb-2'>Upload Documents/Images </Form.Label>
                                            <div
                                                className="dropfile "
                                                onDrop={handleDrop}
                                                onDragOver={handleDragOver}
                                            >
                                                <h3>Drag and drop files here</h3>
                                                <button className='btn btn-primary drpbtn' onClick={handleBrowseFiles}>Browse</button>
                                                <span>Maximum file size 4 MB</span>
                                                <input
                                                    type="file"
                                                    ref={fileInputRef}
                                                    style={{ display: 'none' }}
                                                    onChange={handleFileChange}
                                                    multiple
                                                />
                                            </div>
                                        </div>
                                        <div className='upimg_recover'>
                                            <span className='frprimary'>User can select image for primary image </span>
                                            <div className='d-flex dv_wrap'>
                                                {editFiles &&
                                                    <>
                                                        {editFiles?.map((file, index) => {
                                                            const fileName = file?.file_name;
                                                            const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                            const extension = fileName?.split(".").pop();
                                                            return (
                                                                <>
                                                                    {file.original_file_path == 'service_recovery_edit_files' &&
                                                                        <>
                                                                            <div key={`ns_${index}`} className={`img-thumbnail ${file.primary === 1 ? 'primaryimg' : ''}`} onClick={() => handleImageSelect(index, file)}>
                                                                                {["jpeg", "jpg", "png", "webp"].includes(file.file_path?.split(".")[file.file_path?.split(".").length - 1]
                                                                                ) ? (
                                                                                    <>
                                                                                        <img
                                                                                            src={file.file_path}
                                                                                            alt="Preview"
                                                                                            style={{
                                                                                                maxWidth: "30px",
                                                                                                maxHeight: "30px",
                                                                                                marginRight: "10px",
                                                                                            }}

                                                                                        />
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <span className="">
                                                                                            <img src={Docmnt} className="fileimg" />
                                                                                        </span>
                                                                                    </>
                                                                                )}
                                                                                <span className="rafilename">
                                                                                    {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 7)}... .${extension}`}
                                                                                </span>

                                                                                <button
                                                                                    className="dltbtn"
                                                                                    type="button"
                                                                                    onClick={() =>
                                                                                        handleDeleteImage(index, file.id, file.attachment_type)
                                                                                    }
                                                                                >
                                                                                    <FontAwesomeIcon icon={faCircleXmark} />
                                                                                </button>
                                                                                {/* )} */}
                                                                            </div>
                                                                        </>
                                                                    }
                                                                </>
                                                            );
                                                        })}
                                                    </>
                                                }
                                                {files?.map((file, index) => {
                                                    const fileName = file.name;
                                                    const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                    const extension = fileName?.split(".").pop();
                                                    return (
                                                        <div key={index} className={`img-thumbnail ${selectedKeys.includes(index) ? 'primaryimg' : ''}`} onClick={() => handleImageSelect(index, file)}>
                                                            {["jpeg", "jpg", "png", "webp"].includes(file.name.split(".")[file.name.split(".").length - 1]
                                                            ) ? (
                                                                <>
                                                                    <img
                                                                        src={URL.createObjectURL(file)}
                                                                        alt="Preview"
                                                                        style={{
                                                                            maxWidth: "30px",
                                                                            maxHeight: "30px",
                                                                            marginRight: "5px",
                                                                        }}

                                                                    />
                                                                    <span>
                                                                        {/*file.file_name*/}
                                                                        {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 10)}... .${extension}`}
                                                                    </span>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <span className="d-flex align-items-center">
                                                                        <img src={Docmnt} style={{
                                                                            maxWidth: "30px",
                                                                            maxHeight: "30px",
                                                                            marginRight: "5px",
                                                                        }} />
                                                                        <span>  {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 10)}... .${extension}`}</span>
                                                                    </span>
                                                                </>
                                                            )}


                                                            <button className='dltbtn' type="button" onClick={() => handleDeleteFile(index)}> <FontAwesomeIcon icon={faCircleXmark} color='#656565' /></button>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </Form>
                            </div>
                        </Col>
                    </Row>
                    <div className='ordernext'>
                        <Button variant="contained" onClick={closeserviceRecovery} >
                            Discard
                        </Button>
                        <Button className='trnext' variant="contained" onClick={checkFinish}  >
                            Save
                        </Button>
                    </div>
                    {disLoading &&
                        <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
                    }
                </Modal.Body >
            </Modal>
            <Modal show={addressModalShow} onHide={addressModalClose} centered className='addfrom'>
                <Modal.Header closeButton onClick={addressModalClose}>
                    <Modal.Title>
                        {addressFor == 'RH' || addressFor == 'OH' || addressFor == 'DH' || addressFor == 'SH' ? 'Edit' : 'Add'} Address - {addressFor == 'origin' || addressFor == 'OH' ? orgLabel : (addressFor == 'destination' || addressFor == 'DH' ? destLabel : (addressFor == 'report' || addressFor == 'RH' ? repLabel : getDestination.find(nm => nm.station_id === selectedStation?.station_id)?.label))}</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <Form.Group className='mb-2'>
                        <Form.Label>Handler Name <span>*</span></Form.Label>
                        {/* <Form.Control type="text" onChange={handleAddressChange} name='company_name' placeholder="Company Name" /> */}
                        {handlerList.length === 0 ?
                            <Form.Control
                                type="text"
                                onChange={(e) => setInputAddress(prevFormData => ({ ...prevFormData, handler_org_id: e.target.value }))}
                                name='handler_org_id'
                                placeholder="Handler Name"
                            />
                            :
                            <Select
                                options={handlerList}
                                onChange={(selected) => {
                                    setInputAddress(prevFormData => {
                                        const newFormData = { ...prevFormData, handler_org_id: selected.value }; // , handler_email_id: selected.email 
                                        return newFormData;
                                    });
                                }}
                                placeholder="Select Handler"
                                className='select_handler'
                                name='handler_org_id'
                                isDisabled={['OH', 'DH', 'SH'].includes(addressFor)}
                                value={handlerList.find(option => option.value === inputAddress.handler_org_id) || ''}
                            />
                        }
                    </Form.Group>

                    <Form.Group className='mb-2'>
                        <Form.Label>Email ID  <Link to="#" className="raad_adrss" onClick={addEmailField}>+ Add Email</Link></Form.Label>
                        {/* <Form.Control type="text" onChange={handleAddressChange} name='handler_email_id' placeholder="E-mail" value={inputAddress.handler_email_id || ''} /> */}
                        {inputAddress?.handler_email_id?.map((email, index) => (
                            <div key={index} className="d-flex align-items-center position-relative mb-2">
                                <Form.Control
                                    type="text"
                                    placeholder="E-mail"
                                    value={email}
                                    onChange={(e) => handleEmailChange(index, e.target.value)}
                                    className=""
                                />
                                {inputAddress.handler_email_id.length > 1 && (

                                    <Link to="#" onClick={() => removeEmailField(index)} className="email_del"> <FontAwesomeIcon icon={faCircleXmark} /> </Link>

                                )}
                            </div>
                        ))}
                    </Form.Group>

                    <Form.Group className='mb-2'>
                        <Form.Label>Address </Form.Label>
                        <Form.Control type="text" onChange={handleAddressChange} name='address' placeholder="Address" value={inputAddress.address || ''} />
                    </Form.Group>


                    <Form.Group className='mb-2'>
                        <Form.Label>Telephone No</Form.Label>
                        <Form.Control
                            type="number"
                            onChange={handleAddressChange}
                            name='handler_phone_no'
                            onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 12); }}
                            placeholder="Number"
                            value={inputAddress.handler_phone_no || ''}
                        />
                    </Form.Group>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={addAddress}  >
                        {addressFor == 'OH' || addressFor == 'DH' || addressFor == 'SH' ? 'Update' : 'Add'} Address
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default AddRecovery